<template>
  <div class="p-5 text-right">
    <div @click="exportToCsv" class="btn btn-dark w-32 mr-2 mb-2">
        <DownloadIcon class="w-4 h-4 mr-2" /> Export
    </div>
  </div>

  <FullCalendar ref="fullCalendar" :options="calendarOptions" />

  <div
    v-show="isLoading"
    class="absolute top-0 right-0 h-full w-full bg-white opacity-50 z-50"
  ></div>
  <div id="plan-detail-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <a
          data-dismiss="modal"
          href="javascript:;"
          id="plan-detail-modal-close"
        >
          <XIcon class="w-8 h-8 text-gray-500" />
        </a>
        <div class="modal-body p-10 text-center"></div>
      </div>
    </div>
  </div>

  <div id="plan-modal" class="modal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <a data-dismiss="modal" href="javascript:;">
          <XIcon class="w-8 h-8 text-gray-500" />
        </a>
        <div class="modal-body p-0">
          <div class="p-5 text-center">
            <div class="text-3xl mt-5">{{ $t('employee.plan') }}</div>
            <div class="text-gray-600 mt-2">
              {{ plan.title }}<br />
              {{ plan.branch ? plan.branch.name : '' }}<br />
              {{ new Date(plan.datetimeFrom).toLocaleString('sk-SK') }}
              -
              {{ new Date(plan.datetimeTo).toLocaleString('sk-SK') }}
            </div>
            <div class="text-3xl mt-5">{{ $t('reservation.list') }}</div>
            <div class="text-gray-600 mt-2" v-if="!isPlanLoading">
              <table class="table mt-5">
                <thead>
                  <tr class="bg-gray-200 text-gray-700">
                    <th class="whitespace-nowrap">{{ $t('common.time') }}</th>
                    <th class="whitespace-nowrap">{{ $t('common.title') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="reservation in plan.reservations"
                    :key="reservation.uuid"
                  >
                    <td class="border-b dark:border-dark-5">
                      {{
                        new Date(reservation.reservationFrom).toLocaleTimeString(
                          'sk-SK'
                        )
                      }}
                      -
                      {{
                        new Date(reservation.reservationTo).toLocaleTimeString(
                          'sk-SK'
                        )
                      }}
                    </td>
                    <td class="border-b dark:border-dark-5">
                      {{ reservation.title }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              class="
                col-span-6
                sm:col-span-3
                xl:col-span-2
                flex flex-col
                justify-end
                items-center
              "
              v-show="isPlanLoading"
            >
              <LoadingIcon icon="three-dots" class="w-8 h-8" />
            </div>
          </div>
          <div class="px-5 pb-8 text-center">
            <button
              type="button"
              data-dismiss="modal"
              class="
                btn btn-outline-secondary
                w-24
                dark:border-dark-5 dark:text-gray-300
                mr-1
              "
            >
              {{ $t('common.cancel') }}
            </button>
            <button
              type="button"
              class="btn btn-danger w-24"
              @click="deleteEvent"
            >
              {{ $t('employee.planDelete') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- BEGIN: Success Notification Content -->
  <div
    id="success-notification-content-plan"
    class="toastify-content hidden flex"
  >
    <CheckCircleIcon class="text-theme-9" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('employee.planDeleted') }}</div>
      <!-- <div class="text-gray-600 mt-1">
        Please check your e-mail for further info!
      </div> -->
    </div>
  </div>
  <!-- END: Success Notification Content -->
  <!-- BEGIN: Failed Notification Content -->
  <div
    id="failed-notification-content-plan"
    class="toastify-content hidden flex"
  >
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('employee.planNotDeleted') }}</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent } from 'vue'
import '@fullcalendar/core/vdom'
import FullCalendar from '@fullcalendar/vue3'
import Toastify from 'toastify-js'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import skLocales from '@fullcalendar/core/locales/sk'
import employeeApi from '../../services/employees/employee.api.js'

export default defineComponent({
  components: {
    FullCalendar
  },
  methods: {
    loaderToggle(value) {
      this.isLoading = value
    },
    displayPlan(info) {
      this.isPlanLoading = true
      this.plan = info.event.extendedProps
      this.showPlanModal()
      employeeApi.getPlan(this.employeeUUID, this.plan.uuid).then(
        response => {
          this.plan = response.data
          this.plan.reservations.sort(function(a, b) {
            return new Date(b.datetimeFrom) - new Date(a.datetimeFrom)
          })
          this.isPlanLoading = false
        },
        error => {
          console.log(error)
          this.isPlanLoading = false
        }
      )
    },
    reloadCalendar() {
      this.$refs.fullCalendar.getApi().refetchEvents()
    },
    deleteEvent() {
      employeeApi.deletePlan(this.employeeUUID, this.plan.uuid).then(
        response => {
          Toastify({
            node: cash('#success-notification-content-plan')
              .clone()
              .removeClass('hidden')[0],
            duration: 5000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
          this.reloadCalendar()
          this.hidePlanModal()
        },
        error => {
          console.log(error)
          Toastify({
            node: cash('#failed-notification-content-plan')
              .clone()
              .removeClass('hidden')[0],
            duration: 10000,
            newWindow: true,
            close: true,
            gravity: 'top',
            position: 'right',
            stopOnFocus: true
          }).showToast()
        }
      )
    },
    loadData(info, successCallback, failureCallback) {
      employeeApi
        .getPlanForCalendar(
          this.employeeUUID,
          info.start.toISOString(),
          info.end.toISOString()
        )
        .then(
          response => {
            successCallback(
              response.data.data.map(function(item) {
                const data = {
                  id: item.uuid,
                  title: item.branch ? item.branch.name : item.title,
                  start: item.datetimeFrom,
                  end: item.datetimeTo,
                  extendedProps: item
                }

                if (item.branch !== null) {
                  data.backgroundColor = item.branch.color
                }

                return data
              })
            )
          },
          error => {
            failureCallback(error)
          }
        )
    },
    exportToCsv() {
      employeeApi
        .getCsvExport(
          this.employeeUUID,
          this.$refs.fullCalendar.calendar.view.currentStart.toISOString(),
          this.$refs.fullCalendar.calendar.view.currentEnd.toISOString()
        )
        .then(
          response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'plans.csv')
            document.body.appendChild(link)
            link.click()
          },
          error => {
            console.log(error)
          }
        )
    }
  },
  data() {
    return {
      isLoading: true,
      isPlanLoading: true,
      plan: {
        uuid: '',
        title: '',
        branch: {
          name: ''
        }
      },
      calendarOptions: {
        plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin],
        firstDay: 1,
        locale: skLocales,
        droppable: false,
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
        },
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false
        },
        initialView: 'timeGridWeek',
        navLinks: true,
        editable: false,
        dayMaxEvents: true,
        loading: this.loaderToggle,
        events: this.loadData,
        eventClick: this.displayPlan
      }
    }
  },
  props: {
    employeeUUID: String
  },
  setup() {
    const showPlanModal = () => {
      cash('#plan-modal').modal('show')
    }
    const hidePlanModal = () => {
      cash('#plan-modal').modal('hide')
    }
    return {
      showPlanModal,
      hidePlanModal
    }
  }
})
</script>
